<template>
    <div id="printDiv">
        <h3 class="title">市红十字会{{tips.Title}}</h3>
        <div class="qrcode-box">
            <div class="qrcode" id="qrcode" ref="qrCodeUrl"></div>
        </div>
        <el-row class="box">
            <el-col :span="8" class="box-left">活动时间：</el-col>
            <el-col :span="16" class="box-right">{{tips.ActivityStartTime * 1000 | formatDate}}至{{tips.ActivityEndTime * 1000 | formatDate}}</el-col>
        </el-row>
        <el-row class="box">
            <el-col :span="8" class="box-left">地址：</el-col>
            <el-col :span="16" class="box-right">{{tips.Address}}</el-col>
        </el-row>
        <el-row class="box">
            <el-col :span="8" class="box-left">活动联系人：</el-col>
            <el-col :span="16" class="box-right">{{tips.Leader}}</el-col>
        </el-row>
        <el-row class="box">
            <el-col :span="8" class="box-left">活动联系人手机号：</el-col>
            <el-col :span="16" class="box-right">{{tips.LeaderMobile}}</el-col>
        </el-row>
        <div class="tips">
            <div class="tips-label">说明：</div>
            <div class="tips-label">第一次扫码则为志愿者签到；</div>
            <div class="tips-label">第二次扫码则是志愿者散场签退。请慎重扫码！</div>
        </div>
        <el-button type="primary" id="btnPrint" v-print="'#printDiv'" v-show="false" />
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
    name: 'recruitPrint',
    props:{
        qrCodeForm:{
            type: Object,
            default: null
        },
        tips:{
            type: Object,
            default: null
        },
        qrCodeUrl:{
            typoe: String,
            default: null
        }
    },
    data(){
        return{
            qrCodeDialog: false,
            signTime: [],
            isCreateQRCode :true,
        }
    },
    mounted(){
        const vm = this
        let qrcode = document.getElementById("qrcode")
            if(qrcode !== null){
                qrcode.innerHTML = ''
            }
        vm.qrCodeUrl
        vm.createQRCode()
    },
    methods:{
        print(){
            const printDiv = document.getElementById('btnPrint')
            printDiv.click()
        },
            // 清除生成的二维码
        isShowOpen () {
        const codeHtml = document.getElementById('qrcode');
        codeHtml.innerHTML = '';
        },
        createQRCode(){
            const vm = this
                new QRCode(vm.$refs.qrCodeUrl, {
                    text: vm.qrCodeUrl, // 需要转换为二维码的内容
                    width: 254,
                    height: 254,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            }
    }
}
</script>
<style lang="scss" scoped>
.qrcode-box{
    text-align: center;
}
.qrcode{
    display: inline-block;
    padding: 6px;
    background-color: #fff;
}
.title{
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}
.box{
    margin-bottom: 5px;
    .box-left{
        text-align: right;
    }
    .box-right{

    }
        }
.tips{
    padding-left: 10%;
    color: red;
    .tips-label{
        margin:5px;
    }
}
</style>